<template>
  <div v-if="vm">
    <el-form-item label="申请部门" required>
      <el-input
        :value="vm.acctApplyDeptName"
        readonly
        :disabled="true"
        placeholder="根据当前登录用户"
      />
    </el-form-item>
    <el-form-item label="申请日期" required>
      <el-input :value="vm.acctApplyDateYmd" readonly :disabled="true" />
    </el-form-item>
    <el-form-item label="开通员工姓名" required>
      <work-order-user-select-v2
        v-if="vm.allUserOptions.length"
        v-model="vm.acctEmployeeUsers"
        :allOptions="vm.allUserOptions"
        :disabledNullBeisen="true"
        :multiple-limit="1"
        @input="vm.onAcctEmployeeChange"
      />
    </el-form-item>
    <el-form-item label="开通员工职位" required>
      <el-input
        v-model="vm.acctEmployeePosition"
        readonly
        :disabled="true"
        placeholder="根据所选员工档案"
      />
    </el-form-item>
    <el-form-item label="开通员工手机号" required>
      <el-input
        v-model.trim="vm.acctEmployeePhone"
        maxlength="11"
        placeholder="11位手机号"
      />
    </el-form-item>
    <el-form-item label="申请系统" required>
      <el-select
        v-model="vm.acctSelectedSoftwareIds"
        multiple
        filterable
        collapse-tags
        style="width: 100%"
        placeholder="请选择系统（可多选）"
        @change="vm.onAcctSoftwareSelectionChange"
      >
        <el-option
          v-for="sw in vm.acctSoftwareOptions"
          :key="'sw-' + vm.softwareRowId(sw)"
          :label="vm.acctSoftwareOptionLabel(sw)"
          :value="vm.softwareRowId(sw)"
          :disabled="!vm.acctSoftwareHasHandlerRow(sw)"
        />
      </el-select>
    </el-form-item>
    <el-form-item
      v-for="sid in vm.acctSelectedSoftwareIds"
      :key="'perm-' + sid"
      :label="vm.acctSoftwareNameById(sid)"
      required
    >
      <el-input
        :value="vm.acctSystemPermissions[String(sid)]"
        type="textarea"
        :autosize="{ minRows: 3 }"
        maxlength="200"
        show-word-limit
        placeholder="必填，请填写需要的权限内容"
        @input="(val) => vm.$set(vm.acctSystemPermissions, String(sid), val)"
      />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "WorkSubmitFormAccount",
  inject: {
    workSubmit: {
      default: null,
    },
  },
  computed: {
    vm() {
      return this.workSubmit;
    },
  },
};
</script>
